export const CHAT_AGENT_PROVIDERS = {
  claude: 'claude-code',
  copilot: 'copilot-cli',
  titan: 'titan',
} as const

export const CHAT_AGENT_PROVIDER_LABELS: Record<string, string> = {
  [CHAT_AGENT_PROVIDERS.claude]: 'Claude',
  [CHAT_AGENT_PROVIDERS.copilot]: 'GitHub Copilot',
  [CHAT_AGENT_PROVIDERS.titan]: 'Qubiz Titan',
}

export interface ChatAgentProviderOption {
  provider: string
  displayName: string
  defaultModel?: string | null
  defaultEffort?: string | null
  supportsModelSelection: boolean
  supportsEffortSelection: boolean
}

export interface ChatAgentOptions {
  providers: ChatAgentProviderOption[]
}

export interface ChatAgentSelection {
  agentProvider: string
  model: string | null
  effort: string | null
}
